import apiPath from "../constants/apiPath";
import { ShowToast, Severty } from "./toast";

// Download a report file through the backend proxy. This hides the storage (S3) URL
// from users and forces a real download with a clean filename instead of opening the
// raw URL in a new tab. type is one of: pdf | pdf2 | ppt | docx.
export const downloadReportFile = async (reportId, type, filename) => {
  try {
    if (!reportId) {
      ShowToast("This report is not available for download.", Severty.ERROR);
      return;
    }
    const token = localStorage.getItem("token") || "";
    const base = (apiPath.baseURL || "").replace(/\/+$/, "");
    // 1) Mint a short-lived, single-purpose download token (fast; no file transfer).
    const res = await fetch(
      `${base}/common/report-download-token/${reportId}/${type}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (!res.ok) {
      ShowToast("Download failed. Please try again.", Severty.ERROR);
      return;
    }
    const data = await res.json();
    if (!data || !data.token) {
      ShowToast("Download failed. Please try again.", Severty.ERROR);
      return;
    }
    // 2) Native browser download: the browser fetches the file itself and shows its
    //    download progress bar immediately (unlike fetch-into-memory, which showed
    //    nothing until the whole file had arrived). A hidden iframe avoids navigating
    //    the app away if the server ever responds with an error instead of the file.
    //    The filename comes from the server's Content-Disposition header (an <a>/iframe
    //    download name is ignored cross-origin).
    const params = new URLSearchParams({ dt: data.token });
    if (filename) params.set("filename", filename);
    const url = `${base}/common/report-download/${reportId}/${type}?${params.toString()}`;
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
    document.body.appendChild(iframe);
    setTimeout(() => {
      try {
        document.body.removeChild(iframe);
      } catch (e) {}
    }, 5 * 60 * 1000);
  } catch (err) {
    console.error("Report download failed", err);
    ShowToast("Download failed. Please try again.", Severty.ERROR);
  }
};

export const downloadCertificate = async (certificate) => {
  try {
    // Handle both single certificate object and full record object
    let certData;
    if (certificate.certificates && Array.isArray(certificate.certificates)) {
      // If it's a record with multiple certificates, take the first one
      certData = certificate.certificates[0];
    } else {
      // If it's already a certificate object
      certData = certificate;
    }

    const name = certData.certificate?.name || certData.name || "";
    const nameParts = name.split(" ");
    const firstName = nameParts[0]?.toUpperCase() || "";
    const lastName = nameParts.slice(1).join("_").toUpperCase() || "";

    const serialNumber = certData.sr_number || "";
    const number = serialNumber ? serialNumber.split("-").pop() : "";

    const date = new Date(certData.issueDate);
    const formattedDate = `${String(date.getDate()).padStart(2, "0")}${String(
      date.getMonth() + 1
    ).padStart(2, "0")}${date.getFullYear()}`;

    const fileName = `${firstName}_${lastName}_${number}_${formattedDate}.pdf`;

    const response = await fetch(certData.fileUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Download failed", err);
    // You might want to show a toast or alert here
  }
};